<template>
  <div class="animated fadeIn">
    <b-row class="py-2">
      <b-card header="Editar Tipo de Campaña" class="w-100">
        <b-form @submit.prevent="store" enctype="multipart/form-data">
          <b-row class="px-3">

            <b-form-group
              label="<strong>Nombre *</strong>"
              label-for="name"
              :horizontal="false" class="w-100">
              <b-form-input id="name" type="text" placeholder="Nombre" v-model="campaignType.name" required></b-form-input>
            </b-form-group>
          </b-row>

          <b-row>
            <div class="col float-left">
              <button
                type="submit"
                class="btn btn-brand btn-primary btn-lg pull-right"
                :disabled="!requirements()"
                v-if="mixinCheckPermission('CAMPAIGN_TYPE_EDIT')">
                Guardar
              </button>
            </div>
          </b-row>

        </b-form>
      </b-card>
    </b-row>
  </div>
</template>

<script>

import { request } from '@/helpers/services';
import Multiselect from 'vue-multiselect';
import {getDistributions} from "@/api/distribution-list-api";

export default {

  name: 'editCampaignType',
  components: {
    Multiselect
  },
  data: function () {
    return {
      topmenu: [
        { name: 'Volver', path: '/communications/campaign-type/list', brand:'fa fa-arrow-left'},
      ],
      campaignType:{
        uuid: 0,
        name: "",
      },
      typeOfTemplate: null
    }
  },

  mounted(){
    this.$eventHub.$emit('captureMenu', this.topmenu);
    this.uuid = this.$route.params.uuid;
    this.typeOfTemplate = this.$route.query.typeOfTemplate;
    this.getCampaignType();
  },

  methods: {
    async getCampaignType(){
      try{
        this.$_loadingMixin_showLoading();
        this.campaignType = await request('campaign-type/'+this.uuid,'get',200);

        this.$_loadingMixin_hideLoading();
      }catch(error){
        console.log(error);
      }
    },
    async store(){
      try{
        this.$_loadingMixin_showLoading();

        const payload = {
            name: this.campaignType.name
          };

        this.campaignType = await request('campaign-type/' + this.uuid, 'post', 200, payload);
        this.$_loadingMixin_hideLoading();
        this.$router.push({path: '/communications/campaign-type/list'});

      }catch(error){
        console.log(error);
      }
    },

    requirements(){
      if(!this.campaignType.name){
        return false;
      }else{
        return true;
      }
    }
  },
}
</script>
